'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgFormToggle = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "M9 8h6a4 4 0 0 1 0 8H9a4 4 0 0 1 0-8Zm-6 4a6 6 0 0 1 6-6h6a6 6 0 0 1 0 12H9a6 6 0 0 1-6-6Zm15 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z", clipRule: "evenodd" })
);

module.exports = SvgFormToggle;
//# sourceMappingURL=FormToggle.cjs.js.map
